/* eslint-disable max-len */
import {
  isChunkError,
  isPendingRecoveryFromChunkError,
  tryRecoverFromChunkError,
} from './chunkError';

const skipErrorsWithNames = ['RPCRequestError'];

const skipErrorsWithMessages = [
  // ошибки гидрации - если чанк отвалился или в браузере включен переводчик или что угодно
  'Minified React error #418', // https://react.dev/errors/418 - Hydration failed because the server rendered HTML didn't match the client.
  'Minified React error #422', // https://react.dev/errors/422 - There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.
  'Minified React error #423', // https://react.dev/errors/423 - There was an error while hydrating but React was able to recover by instead client rendering the entire root.
  'Minified React error #425', // https://react.dev/errors/425 - Text content does not match server-rendered HTML.
  'Minified React error #329', // https://react.dev/errors/329 - Unknown root exit status. (мы тоже не знаем)
  // тестовая ошибка core-logger
  // https://gitlab.corp.mail.ru/mail-core/logger/-/blob/master/docs/install-inline.md
  `Unexpected token '~', "~" is not valid JSON`,
  'Unexpected token ~ in JSON at position 0',
  // мы evaluate не делаем так что можно не обращать внимание :)
  'is not a valid XPath expression',
];

const skipErrorsWithStack = [
  // экстеншены
  'chrome://userjs',
  'chrome://internal',
  'chrome-extension:',
  'moz-extension:',
  'ms-browser-extension:',
  'safari-web-extension:',
  // скрипты
  '<anonymous>:',
  '__puppeteer_evaluation_script__',
  // 3rd party
  'mc.yandex.ru/metrika',
  'privacy-cs.mail.ru/static/sync-loader',
  'https://smartcaptcha.yandexcloud.net/captcha.js',
  'https://yastatic.net/partner-code-bundles',
  'static/sync-loader.js', // https://ad.mail.ru/static/sync-loader.js и https://privacy-cs.mail.ru/static/sync-loader.js
];

export default function filterError(error: Error) {
  console.warn('Caught error', error.name, error.message, error.stack);

  if (isPendingRecoveryFromChunkError()) {
    // после ошибки чанка можем получить всякие еще ошибки (423 etc), но тут уже совсем вообще пофигу
    console.warn('pending reload from chunk error, skipping reporting');
    return false;
  }

  if (isChunkError(error)) {
    if (tryRecoverFromChunkError()) {
      // не шлем ошибку, если пытаемся восстановиться
      return false;
    }
  }

  if (
    error.name === 'TypeError' &&
    error.message === 'Failed to fetch' &&
    error.stack?.includes('onBeforeUnload')
  ) {
    console.warn('ошибка трейсера на заливку сессии по закрытию окна');
    return false;
  }

  if (skipErrorsWithNames.includes(error.name)) {
    console.warn('Filtering error by name: ' + error.name);
    return false;
  }

  const matchingMessage = skipErrorsWithMessages.find((x) =>
    error.message.includes(x),
  );
  if (matchingMessage) {
    console.warn('Filtering error by message: ' + error.message);
    return false;
  }

  const matchingStack =
    error.stack && skipErrorsWithStack.find((x) => error.stack?.includes(x));
  if (matchingStack) {
    console.warn('Filtering error by stack: ' + matchingStack);
    return false;
  }
}
